import { useEffect, useState } from "react";
import SelectBox, { menuItemType } from "./selectBox";
import useGetUserGroupSub from "../hooks/useGetUserGroupSub";
import { SelectChangeEvent } from "@mui/material";
import userStorage from "../utils/userStorage";
import { useI18n } from "../locales";

interface Props {
  groupSub: string;
  setGroupSub: React.Dispatch<React.SetStateAction<string>>;
  width?: string | number;
}

export const SelectBoxGroupId = ({
  groupSub,
  setGroupSub,
  width = 175,
}: Props) => {
  const { t } = useI18n();
  const user = userStorage.get();
  const [groupSubOpen, setGroupSubOpen] = useState(false);
  const [isActive, setIsActive] = useState(false); // 로그인 유저의 담당기관이 5자리 이하일때 활성화

  // 하위 담당기관 리스트
  const { data: GroupSubData } = useGetUserGroupSub();

  const userGroupSubList: menuItemType[] = [
    { value: "all", title: t.common.all }, // 첫 번째 값 추가
  ];
  if (GroupSubData) {
    for (let i = 0; i < GroupSubData.length; i++) {
      userGroupSubList.push({
        value: GroupSubData[i].group_id,
        title: GroupSubData[i].name,
      });
    }
  }

  useEffect(() => {
    if (user && user.area.length <= 5) {
      setIsActive(true);
      return;
    }
    setIsActive(false);
  }, [user]);

  const handleGroupSubChange = (
    event: SelectChangeEvent<typeof groupSub>
  ) => {
    setGroupSub(String(event.target.value));
  };

  if (!isActive) {
    return null;
  }

  return (
    <SelectBox
      open={groupSubOpen}
      filter={groupSub}
      handleChange={handleGroupSubChange}
      handleClose={() => {
        setGroupSubOpen(false);
      }}
      handleOpen={() => {
        setGroupSubOpen(true);
      }}
      title={t.control.group}
      menuItems={userGroupSubList}
      width={width}
      mr="0px"
      srLabel={t.control.group}
    />
  );
};
